var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRib(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24 10.76h2.88m-2.88 3.88h4.8M18.72 6H5.28c-1.06 0-1.92.86-1.92 1.92v7.68c0 1.06.86 1.92 1.92 1.92h13.44c1.06 0 1.92-.86 1.92-1.92V7.92c0-1.06-.86-1.92-1.92-1.92zm-4.8 2.88h3.84v2.88h-3.84V8.88z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgRib;